import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';
import { PostPayload } from '..';
import {
  AllAPIResponses,
  CarbonError,
  NodeTypeTemplateType,
} from './../../../index';

type Params = {
  id: number;
};

const put = async (
  params: Params,
  payload: Partial<PostPayload>,
  headers?: Headers
): Promise<AllAPIResponses<NodeTypeTemplateType>> => {
  try {
    const resp = await req.put(
      `/api/nodetypetemplates/${params.id}`,
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as NodeTypeTemplateType,
          response: clone,
        };
      case 304:
        return { error: new Error('Not Modified'), response: clone };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default put;
